import { createContext } from "react";

import Menu from "api/types/Menu";
import MenuGroup from "api/types/MenuGroup";
import MenuItem from "api/types/MenuItem";

const MenuContext = createContext<{
	menu: Menu;

	menuGroupBySlug: {
		[menuGroupSlug: string]: MenuGroup;
	};

	menuItemById: {
		[menuItemId: string]: MenuItem;
	};
}>({} as any);

export default MenuContext;
